import { render, staticRenderFns } from "./SidebarList.vue?vue&type=template&id=64d201ce"
import script from "./SidebarList.vue?vue&type=script&lang=js"
export * from "./SidebarList.vue?vue&type=script&lang=js"
import style0 from "./SidebarList.vue?vue&type=style&index=0&id=64d201ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports